module.exports = __webpack_public_path__ + "img/attachmentSetting-2.482fa6f.png";